import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// Dispara um PageView no Meta Pixel e no Google Analytics a cada MUDANÇA de rota
// (navegação client-side da SPA). O carregamento inicial já é contado pelos
// snippets em index.html, então pulamos a primeira renderização para não duplicar.
export default function RouteTracker() {
  const { pathname, search } = useLocation();
  const first = useRef(true);

  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    const page = pathname + search;
    if (typeof window.fbq === "function") {
      window.fbq("track", "PageView");
    }
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: page,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [pathname, search]);

  return null;
}
